import React from "react";
import Product from "../../components/Warehousing/Product";
import Stats from "../../components/Warehousing/Stats";
import MainLayout from "../../common/Layout";
//import Banner from "../../common/Banner";
import AboutSection from "../../common/AboutSection";
import EcommerceSection from "../../components/Home/EcommerceSection";

import {
  BannerData,
  EcommerceSectionData,
  EcommerceSection2Data,
  SustainabilityData,
  InovationData,
} from "../../Data/ContractLogistic";
import Level from "../../common/Level";
import WhyWorkWithUs from "../../components/Career/WhyWorkWithUs";
import WhyWorkWithUsReverse from "../../components/Career/WhyWorkWithUsReverse";
import VideoArea from "../../common/VideoArea";
import CenterHeading from "../../common/CenterHeading";
import FourServices from "../../components/Airfreight/FourServices";
import {
  ContractLogisticPanelsData,
  ContractLogisticsServicesArray,
  FourServicesContractData,
} from "../../Data/Freight";
import AirfreightServices from "../../components/Airfreight/AirfreightServices";
import ImagePanel from "../../common/ImagePannel";
import { NetworkContractLogistics, NetworkDataCargo } from "../../Data/network";
import Banner from "../../components/Career/LifeAtMacworld/Banner";
import BannerSmallScreen from "../../components/Career/SmallScreenBanner";
import Network from "../../components/Home/Network";
import { Grid } from "antd";
import PageOverview from "../../common/PageOverview";
import ValueAddedServices from "../../common/ValueAddedServices";
import CaseStudies from "../../common/CaseStudies";
import ContactUsBanner from "../../common/ContactUsBanner";
import CertificateComponent from "../../common/CertificateComponent";

const { useBreakpoint } = Grid;

const ContractLogistic = () => {
  const screens = useBreakpoint();
  return (
    <>
      <MainLayout>
        {screens.xs ? (
          <BannerSmallScreen
            bgImage={BannerData.image}
            heading={BannerData?.title}
            text={BannerData?.desc}
          />
        ) : (
          <Banner
            bgImage={BannerData.image}
            title={BannerData?.title}
            desc={BannerData?.desc}
            height="55vh"
          />
        )}

        <PageOverview
          title={"A FULL SPECTRUM OF SERVICES AND INTEGRATED SOLUTIONS"}
          freightTitle={"Customer Engagement"}
          Content1={
            "With innovative and sustainable operations, Macworld Technology offers end-to-end supply chain solutions that optimize your complete logistics journey. As a world leader in logistics, we provide dependable services that create long-lasting relationships to all industries. We develop, implement, and oversee your supply chain strategy, from production support to distribution, reverse logistics, and circular logistics, making sure you meet your customer promises regardless of complexity or global reach.."
          }
          Content3={
            "We believe that operational excellence is a continuous journey and our aim is to always support our customers as they move up in the value chain. We do that through design principles and process standardization, controlling all project implementation, site & transport classification assessment and our continuous improvement culture."
          }
          showButton={false}
        />
        <CenterHeading
          Heading={"Mac World Contract Logistics"}
          showLine={true}
          color={"#021d49"}
          width="28%"
        />

        <VideoArea
          video_url={
            "https://www.youtube.com/embed/VSjJ8Budwi8?si=KkqYddSnnfwfD0iq"
          }
        />

        <AirfreightServices
          ServiceArray={ContractLogisticsServicesArray}
          headingText={"OUR SERVICES"}
        />

        {/* <Stats bgColor={"#f7f7f7f7"} /> */}

        <ValueAddedServices
          content={[
            {
              heading: "ON BOARD COURIER",
              text: "Sometimes a critically urgent or high value shipment requires the personal touch to ensure it is accompanied all the way to the final destination.  We have a team of trained, fully insured couriers on hand to reliably deliver those special shipments.",
            },
            {
              heading: "ON BOARD COURIER",
              text: "Sometimes a critically urgent or high value shipment requires the personal touch to ensure it is accompanied all the way to the final destination.  We have a team of trained, fully insured couriers on hand to reliably deliver those special shipments.",
            },
            {
              heading: "ON BOARD COURIER",
              text: "Sometimes a critically urgent or high value shipment requires the personal touch to ensure it is accompanied all the way to the final destination.  We have a team of trained, fully insured couriers on hand to reliably deliver those special shipments.",
            },
          ]}
          logoImage="https://www.cevalogistics.com/images/original/icon_consumer_centric-200-326.webp"
          image={"Reasons to choose MacWorld Logistics?"}
          heading="Reasons to choose MacWorld Logistics?"
          showButton={false}
        />
        <div style={{ margin: "4rem 0" }}></div>

        <Network data={NetworkContractLogistics} />

        <CertificateComponent
          heading={"SMART solutions"}
          contents={[
            "In order to meet your demands with the most recent, cutting-edge best practices based on standardized, reproducible processes & systems on a global scale, we provide Standardized 'Best Practice' alternatives with tested concepts through our SMART SOLUTIONS The goal of SMART Solutions is to provide excellent service quality. Process descriptions, standard system configuration, materials and data flows, layout, flow decision tree, productivity benchmark, and training materials are all included in the documentation.",
          ]}
          imageSrc={
            "https://www.cevalogistics.com/images/ratio_100_x_large_picture/Beneluxteam_DL_1478-768-768.webp"
          }
        />

        <CertificateComponent
          heading={"Innovation across the supply chain"}
          contents={[
            "Thanks to automated equipment devoted to important activities in our warehouses, we collaborate with esteemed partners to adopt the most cutting-edge technology in order to guarantee the greatest service quality for our customers",
          ]}
          imageSrc={
            "https://www.cevalogistics.com/images/ratio_100_x_large_picture/CEVA-Traineecampaign-HR11_0-768-768.webp"
          }
          row="row-reverse"
          listData={[
            "Encourage new businesses to create supply chain technologies",
            "Join forces with both new and well-known brands",
            "Make research investments to create digital supply networks",
            "Order pickers and robots collaborating directly to maximize picking output",
            "Enhanced automation for a conventional warehouse administration system",
            "Automated order preparation and pickup to boost efficiency",
            "Drones could improve accuracy and dependability of inventory",
          ]}
        />

        <CertificateComponent
          heading={"Sustainability"}
          contents={[
            "Macworld Technologies prioritizes its environmental stewardship and societal duty as a worldwide logistics company.",
          ]}
          imageSrc={
            "https://www.cevalogistics.com/images/ratio_100_x_large_picture/sustainable-shutterstock_145644622-768-768.webp"
          }
          listData={[
            "Consolidation Hubs: lowering delivery to city centers",
            "Initiatives for zero landfills and recycling solutions",
            "Electric cars - using clean fuel to power our cars",
            "Solar panel solutions: using the sun's energy to power our fleet and warehouses",
          ]}
        />

        <CenterHeading
          Heading={"CASE STUDIES"}
          color={"#021d49"}
          showLine={true}
        />
        <p style={{ textAlign: "center", fontSize: "2rem" }}>
          We partner with leaders and specialists across all industries,
          discover our success stories.
        </p>
        <CaseStudies />
        <ContactUsBanner />

        {/* 
                <WhyWorkWithUsReverse
                    bgColor={"#f7f7f7f7"}
                    point={true}
                    title={InovationData.title}
                    Content1={InovationData.Content1}
                    Image={InovationData.img}
                    items={InovationData.items}
                />
                <WhyWorkWithUs
                    point={true}
                    bgColor={"white"}
                    title={SustainabilityData.title}
                    Content1={SustainabilityData.Content1}
                    Image={SustainabilityData.img}
                    items={SustainabilityData.items}
                />

                <Network data={NetworkDataCargo} />

                    {ContractLogisticPanelsData.map((e, i) =>
          <ImagePanel heading={e.title} key={"panel" + i} />
        )} */}
      </MainLayout>
    </>
  );
};

export default ContractLogistic;
